import styled from 'styled-components';
import { ChildrenType, ListWrapperProps } from 'models/Common/commonTypes';
import { font, palette, zIndex } from 'styles/Global/globalStyles';
import { TableCellProps, TableCellTypes } from 'models/Hospital/paginationTypes';
import { BackgroundColor, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { Radius } from 'styles/Global/objectStyles';
import { Body5Regular } from 'styles/Global/typography';

export const Layout = ({ children }: ChildrenType) => {
    return <PaginationLayout>{children}</PaginationLayout>;
};

export const TableLayout = ({ children }: ChildrenType) => {
    return <TableLayoutCss>{children}</TableLayoutCss>;
};

export const HeaderWrapper = ({ children, $showShadow = false }: ChildrenType & { $showShadow?: boolean }) => {
    return <HeaderWrapperCss $showShadow={$showShadow}>{children}</HeaderWrapperCss>;
};
export const AdminHeaderWrapper = ({ children }: ChildrenType) => {
    return <AdminHeaderWrapperCss>{children}</AdminHeaderWrapperCss>;
};

// !추후 managing-patients쪽 cell 오늘 진료 마지막 부분 확인 필요
export const TableCell = ({ children, $width, $idx, $type, onClick, $justifyContent, $padding, hover, cellType, $gap, diagnosisStatus, $maxWidth, $show, $height }: TableCellProps) => {
    return (
        <TableCellCss
            $padding={$padding}
            $width={$width}
            $idx={$idx}
            $type={$type}
            onClick={onClick}
            $cellType={cellType}
            $justifyContent={$justifyContent}
            $gap={$gap}
            $diagnosisStatus={diagnosisStatus}
            $maxWidth={$maxWidth}
            $show={$show}
            $height={$height}
            onMouseEnter={() => cellType && hover && hover(cellType)}
            onMouseLeave={() => cellType && hover && hover('')}
        >
            {children}
        </TableCellCss>
    );
};

export const ListWrapper = ({ children, onClick, $borderBottom = 'none' }: ListWrapperProps) => {
    return (
        <ListWrapperCss onClick={onClick} $borderBottom={$borderBottom}>
            {children}
        </ListWrapperCss>
    );
};
export const AdminListWrapper = ({ children, onClick }: ListWrapperProps) => {
    return <AdminListWrapperCss onClick={onClick}>{children}</AdminListWrapperCss>;
};

export const FooterLayout = ({ children }: ChildrenType) => {
    return <FooterLayoutCss>{children}</FooterLayoutCss>;
};

const PaginationLayout = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    flex-direction: column;
`;
const TableLayoutCss = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    flex-direction: column;
    border-radius: 4px;
    border: 1px solid ${BorderColor.color_border_normal};
`;

const HeaderWrapperCss = styled.div<{ $showShadow?: boolean }>`
    display: flex;
    width: 100%;
    height: 48px;
    border-radius: ${Radius.radius_4} ${Radius.radius_4} 0 0;
    background-color: ${BackgroundColor.color_background_neutral};
    border-bottom: 1px solid ${BorderColor.color_border_neutral};
    /* Strong shadow for sticky header effect, only if $showShadow is true */
    box-shadow: ${({ $showShadow }) => ($showShadow ? '0 8px 16px -4px rgba(0,0,0,0.18)' : 'none')};
    & > div:last-child {
        border-right: none;
        max-width: 60px;
    }
`;
const AdminHeaderWrapperCss = styled.div`
    display: flex;
    width: 100%;
    height: 48px;
    border-radius: ${Radius.radius_4};
    background-color: ${BackgroundColor.color_background_neutral};
    border-bottom: 1px solid ${BorderColor.color_border_neutral};
    & > div:last-child {
        border-right: none;
    }
`;

const TableCellCss = styled(Body5Regular)<TableCellTypes>`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: ${(props) => props.$justifyContent};
    width: ${(props) => props.$width};
    min-width: ${(props) => !props.$maxWidth && props.$width};
    max-width: ${(props) => props.$maxWidth};
    height: ${(props) => props.$height ?? '100%'};
    border-right: 1px solid ${BorderColor.color_border_neutral};
    /* border: 1px solid ${BorderColor.color_border_neutral}; */
    font-size: ${(props) => props.$type !== 'header' && font.size[16]};
    font-weight: ${(props) => props.$type === 'name' && font.weight.semiBold};
    color: ${(props) => props.$type === 'header' && palette.gray};
    padding: ${(props) => props.$padding ?? '0 14px'};
    cursor: ${(props) => props.onClick && 'pointer'};
    overflow: ${(props) => props.$cellType === 'processBarCell' && 'visible'};
    gap: ${(props) => props.$gap ?? '0'};
    ${(props) =>
        (props.$diagnosisStatus === 'noshow' || props.$diagnosisStatus === 'reschedule') &&
        `
        text-decoration: line-through;
        color: ${TextColor.color_text_light};
        -webkit-text-decoration: line-through;
        text-decoration-line: line-through;
        text-decoration-style: solid;
      `};

    &:last-child {
        border-right: none;
    }

    @media (max-width: 1600px) {
        display: ${(props) => props.$show !== 'always' && (props.$idx === 2 || props.$type === 'gradeName' || props.$type === 'noneDisplay') && 'none'};
    }
`;

const ListWrapperCss = styled.div<{ $borderBottom: string }>`
    display: flex;
    width: 100%;
    height: 60px;
    border-bottom: 1px solid ${BorderColor.color_border_neutral};
    cursor: pointer;
    & > div:last-child {
        border-right: none;
        max-width: 60px;
    }
    &:last-child {
        border-bottom: ${(props) => props.$borderBottom};
    }
    &:hover {
        background-color: ${BackgroundColor.color_background_light};
    }
`;
const AdminListWrapperCss = styled.div`
    display: flex;
    width: 100%;
    height: 60px;
    border-bottom: 1px solid ${BorderColor.color_border_neutral};
    cursor: pointer;
    & > div:last-child {
        border-right: none;
    }
    &:hover {
        background-color: ${palette.lightGray};
    }
`;

const FooterLayoutCss = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 36px;
    margin-top: 36px;
    gap: 4px;
`;
